import './modalFooter.scss';

type FooterProps = {
  children: JSX.Element;
}

export const ModalFooter = ({ children }: FooterProps) => <div className="modal-footer">{children}</div>;